import { defineComponent, inject, ref } from 'vue';
import SButton from '@/components/stemdo-components/s-button/SButton.vue';
import SModalCentered from '@/components/stemdo-components/s-modal-centered/SModalCentered.vue';
import { ButtonGroupModals } from '../../../buttonsGroup';
import { TeamRequest } from '@/shared/model/team-request.model';
import TeamRequestService from '@/sections/admin/entities/team-request/team-request.service';
import { useI18N } from '@/plugins/i18n';

export default defineComponent({
  props: {
    onSuccess: {
      type: Function,
      required: true
    },
    teamRequest: {
      type: Object as () => TeamRequest,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    },
    onClose: {
      type: Function,
      required: true
    },
    refreshTeamRequest: {
      type: Function,
      required: true
    }
  },
  components: {
    SButton,
    SModalCentered
  },
  setup(props) {
    const customModalProps = { bodyPaddingY: 0, fullWidthFooter: true };
    const teamRequestService: TeamRequestService = inject('teamRequestService');
    const i18n = useI18N();

    const handleClose = () => {
      props.onClose(ButtonGroupModals.SEND_PROPOSAL);
    };

    const handleAccept = async () => {
      await teamRequestService.partialUpdate(props.teamRequest);
      props.onSuccess(i18n.t('teamRequestDetail.modal.manager.sendProposal.popUp'));
      props.onClose(ButtonGroupModals.SEND_PROPOSAL);
      props.refreshTeamRequest();
    };

    return {
      customModalProps,
      handleClose,
      handleAccept
    };
  }
});
